import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { Download, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function QR() {
  return (
    <>
      <Header />
      <main className="max-w-3xl mx-auto px-6 py-16 min-h-[70vh]">
        <Link
          to="/"
          data-testid="qr-back"
          className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-red-600 mb-6 hover:text-red-500"
        >
          <ArrowLeft size={14} /> Back home
        </Link>
        <div className="text-xs uppercase tracking-[0.3em] text-red-600 mb-4">
          Scan to schedule
        </div>
        <h1 className="font-display font-black uppercase text-white text-4xl sm:text-5xl tracking-tight">
          Storm Damage Pros QR Code
        </h1>
        <p className="text-slate-400 mt-3 max-w-xl">
          Point any phone camera at this code to open the site instantly. Save it for business
          cards, yard signs, vehicle wraps, door hangers, or flyers.
        </p>

        <div className="mt-10 bg-white p-8 inline-block">
          <img
            src="/qr-code.png"
            alt="QR code to roof-inspection-book.emergent.host"
            data-testid="qr-image"
            className="w-[320px] h-[320px] block"
          />
        </div>

        <div className="mt-8 flex flex-col sm:flex-row gap-3 max-w-md">
          <a
            href="/qr-code.png"
            download="storm-damage-pros-qr.png"
            data-testid="qr-download"
            className="bg-red-600 text-white font-bold uppercase tracking-wide hover:bg-red-500 px-6 py-4 inline-flex items-center justify-center gap-2 transition-colors"
          >
            <Download size={16} /> Download QR
          </a>
          <a
            href="/qr-code.png"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="qr-open"
            className="bg-transparent border-2 border-slate-700 text-white font-bold uppercase tracking-wide hover:border-red-600 hover:text-red-600 px-6 py-4 inline-flex items-center justify-center gap-2 transition-colors"
          >
            Open full size
          </a>
        </div>

        <p className="text-slate-500 text-sm mt-8">
          Direct image URL: <code className="text-red-500">/qr-code.png</code>
        </p>
      </main>
      <Footer />
    </>
  );
}
